export const ReservationHistory = {
  HeaderTitle: '予約履歴',
  Card: {
    Label: {
      ReserveDate: '予約日時:',
      PharmacyName: '薬局名:',
    },
  },
};
